/** Shared Arabic labels for assistive technologies */
export const A11Y = {
  skipToContent: "تخطي إلى المحتوى الرئيسي",
  mainContent: "المحتوى الرئيسي",
  mainNav: "التنقل الرئيسي",
  closeDialog: "إغلاق",
  toggleSidebar: "إظهار أو إخفاء القائمة الجانبية",
  openMenu: "فتح القائمة",
  loading: "جاري التحميل",
  delete: "حذف",
  edit: "تعديل",
  search: "بحث",
  clearSearch: "مسح البحث",
  showPassword: "إظهار كلمة المرور",
  hidePassword: "إخفاء كلمة المرور",
  notifications: "الإشعارات",
} as const;

export const MAIN_CONTENT_ID = "main-content";
